import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "libs";

export class AdminApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getAdminList = async (): Promise<Result> => {
        return await axiosClient.get(`/management/admin/list`, this.config)
    }
    getAdminFilter = async (title: string): Promise<Result> => {
        return await axiosClient.get(`/management/admin/list/filter?value=${title}`, this.config)
    }
    postAdminCreate = async (username: string): Promise<Result> => {
        return await axiosClient.post(`/management/admin/create/${username}`, {}, this.config);
    }
    postAdminDelete = async (username: string): Promise<Result> => {
        return await axiosClient.post(`/management/admin/delete/${username}`, {}, this.config);
    }
}
